import { BaseRequest } from "./baseRequest";
import { ConfSearchParameter } from "..";

export class AritcoRequest extends BaseRequest {

  updateConfigurations: boolean;

  updateProgress: boolean;

  aritcoCopyTargets: boolean;

  weekIntervals: boolean;

  updateSlotDate: boolean;

  leadTime: boolean;

  slotDate: string;

  sessionId: number;

  confId: number;

  productId: number;
}